import React, { useState } from 'react'

import { AiOutlineHome } from 'react-icons/ai'
import { AiOutlineUser } from 'react-icons/ai'
import { BiBook } from 'react-icons/bi'
import { RiSuitcaseLine } from 'react-icons/ri'


const Menu = (props) => {
  const hasIcon = props.hasIcon;
  const [activeNav, setActiveNav] = useState('#');

  return (
    <div className='links'>
      <a href="/#" onClick={() => setActiveNav("#")} className={activeNav === '#' ? 'active' : ''} aria-label="home page" title="home page">{hasIcon ? <AiOutlineHome /> : 'Home'}</a>
      <a href="/#about" onClick={() => setActiveNav("#about")} className={activeNav === '#about' ? 'active' : ''} aria-label="about section" title="about section">{hasIcon ? <AiOutlineUser /> : 'About'}</a>
      <a href="/#experience" onClick={() => setActiveNav("#experience")} className={activeNav === '#experience' ? 'active' : ''} aria-label="experience section" title="experience section">{hasIcon ? <BiBook /> : 'Experience'}</a>
      <a href="/#portfolio" onClick={() => setActiveNav("#portfolio")} className={activeNav === '#portfolio' ? 'active' : ''} aria-label="portfolio section" title="portfolio section">{hasIcon ? <RiSuitcaseLine /> : 'Portfolio'}</a>

    </div>
  )
}

export default Menu